import React, { memo } from "react";

import Location from "./Location";
import styles from "./style.css";

export const AutocompleteLocations = memo(props => {
  const { results = [], onResultClick } = props;

  const locations = results.filter(res => res.type === "city");

  if (locations.length > 0) {
    return (
      <ul class={styles.container}>
        {locations.map((result, i) => (
          <Location key={i} {...result} onClick={onResultClick} />
        ))}
      </ul>
    );
  }
  return null;
});
